<craft-icon
  *ngIf="category.isPrivate && portal.restrictedAccess"
  class="category-lock svg-icon"
  [matTooltip]="'common.text65' | craftTerm"
  name="idea--lock"
></craft-icon>
